import { useCallback } from 'react';
import { useLoginUserWithAppleMutation } from 'shared/hooks/queries/use-login-user-with-apple-mutation';

export const useLoginWithApple = () => {
  const { mutateAsync, error, reset, isPending } =
    useLoginUserWithAppleMutation();

  const login = useCallback(async () => {
    await mutateAsync();
  }, [mutateAsync]);

  return { login, error, reset, isLoading: isPending };
};
